import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { MAX_CHARS, truncateWithMiddleEllipsis } from '@shared/utils/truncateWithMiddleEllipsis'
import { useId } from 'react'

type TruncatedStringWithTooltipProps = {
  name: string
  ellipsisPosition?: 'end' | 'middle'
  maxChars?: number
}

const TruncatedStringWithTooltip: React.FC<TruncatedStringWithTooltipProps> = ({
  name,
  ellipsisPosition = 'end',
  maxChars = MAX_CHARS,
}) => {
  const tooltipId = useId()
  const showTooltip = name.length > maxChars

  const displayString =
    ellipsisPosition === 'end' && showTooltip
      ? `${name.slice(0, maxChars)}...`
      : truncateWithMiddleEllipsis(name)

  return (
    <Tooltip
      id={`${tooltipId}-tooltipLongString`}
      title={name}
      placement="top"
      disableHoverListener={!showTooltip}
      disableFocusListener={!showTooltip}
      disableTouchListener={!showTooltip}>
      <Typography variant="body1">{displayString}</Typography>
    </Tooltip>
  )
}

export default TruncatedStringWithTooltip
